<template>
  <!--
      	作者：luoyiming
      examine.vue
      	时间：2020-06-01
      	描述：插件中心-分销-提现申请-弹窗
      -->
  <el-dialog title="审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="refund">
      <div class="refund_item">
        <div class="item">退款说明</div>
        <div class="item_name">{{params.status_text}}</div>
      </div>
    </div>
    <el-form size="small" :model="form1" ref="form1">
      <el-form-item label="支付总金额：" :label-width="formLabelWidth">
        <div class="">
          <span class="red">￥ {{total_money}}</span> 元
        </div>
      </el-form-item>
      <el-form-item label="审核状态：" :label-width="formLabelWidth">
        <el-radio-group v-model="form1.is_agree">
          <el-radio :label="10">已同意</el-radio>
          <el-radio :label="20">已拒绝</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="原因说明：" :label-width="formLabelWidth">
        <el-input v-model="form1.refuse_desc" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="实际退款金额：" :label-width="formLabelWidth">
        <el-input v-model="form1.refund_money" type="number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="退款后技师所得金额：" :label-width="formLabelWidth">
        <el-input v-model="form1.waiter_price" type="number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="退款后商户所得金额：" :label-width="formLabelWidth">
        <el-input v-model="form1.supplier_price" type="number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="退款后平台所得金额：" :label-width="formLabelWidth">
        <el-input v-model="form1.sys_price" type="number" autocomplete="off" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import OrderApi from "@/api/order.js";
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: "180px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false,
      form1: {
        is_agree: 10,
        order_refund_id: "",
        refuse_desc: "",
        refund_money: 0,
        supplier_price: 0,
        waiter_price: 0,
        sys_price: 0
      },
      params: "",
      sys_price: 0
    };
  },
  props: ["open_edit", "form"],
  created() {
    // yong
    console.log(this.form)
    this.form1.order_refund_id = this.form.order_refund_id;
    this.params = this.form.params;
    this.form1.refund_money = this.params.price;
    this.total_money = this.form.order_master.pay_price;
    this.dialogVisible = this.open_edit;
  },
  watch: {
    "form1.supplier_price": function(newVal, oldVal) {
      this.calculateSysPrice();
    },
    "form1.waiter_price": function(newVal, oldVal) {
      this.calculateSysPrice();
    },
    "form1.refund_money": function(newVal, oldVal) {
      this.calculateSysPrice();
    }
  },
  methods: {
    calculateSysPrice() {
      let supplier_price = parseFloat(this.form1.supplier_price) || 0;
      let waiter_price = parseFloat(this.form1.waiter_price) || 0;
      let refund_money = parseFloat(this.form1.refund_money) || 0;
      this.sys_price =
        this.total_money - supplier_price - waiter_price - refund_money;
      if (this.sys_price < 0) {
        this.$message.error("输入的金额总和大于实际支付金额");
        this.form1.sys_price = 0;
      } else {
        let a=Number(this.sys_price)
        this.form1.sys_price =a.toFixed(2) ;
      }
    },
    // 提交审核
    submit() {
      let self = this;
      if (self.sys_price < 0) {
        self.$message.error("输入的金额总和大于实际支付金额,请从新修改");
        return;
      }
      let params = self.form1;
      self.$refs.form1.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          OrderApi.Approval(params, true)
            .then(data => {
              self.submit_loading = false;
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.refund {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .refund_item {
    height: 80px;
    width: 100%;
    border-radius: 16px;
    background: #eee;
    position: relative;
    margin: 20px 0;
    .item {
      position: absolute;
      top: 0;
      left: 0;
      padding: 4px 10px;
      border-radius: 16px 0 16px 0;
      background: #666;
      color: #fff;
      font-weight: bold;
    }
    .item_name {
      position: absolute;
      left: 23px;
      right: 23px;
      top: 36px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/order/refund/examine.vue